import * as React from "react";
import { useMutation } from "react-query";
import { useParams } from "react-router";
import styled from "styled-components/macro";
import { RadioProceed } from "../../../component/component.style";
import { useRecommendation } from "../../../contexts/recommendation-context";
import * as fonts from "../../../styles/fonts";
import * as mq from "../../../styles/mediaQueries";
import { incomeMultiplier } from "../../../utils/enquiry";
import { amount } from "../../../utils/helpers";
import { FewMoreQuestionsModal } from "./FewMoreQuestionsModal";

const Detail = ({ label, value }) => {
  return (
    <div
      css={`
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 0.6em;
        color: #4e4e4e;
        font-size: 0.96em;
        gap: 0 1em;
      `}
    >
      <div
        css={`
          max-width: calc(100% - 7em);
        `}
      >
        {label}
      </div>
      <div
        css={`
          font-weight: 700;
          min-width: max-content;
        `}
      >
        {value}
      </div>
    </div>
  );
};

function ResultSheet({ data }) {
  const [fewMoreQuestionsModalShow, setFewMoreQuestionsModalShow] =
    React.useState(false);

  const {
    answers: { age, income },
    broker,
  } = useRecommendation();

  const { enquiryId } = useParams();

  const { mutateAsync: getIncomeMultiplier } = useMutation(() =>
    incomeMultiplier({
      age: age,
      sum_assured: data["Total sum assured"],
      annual_income: income,
      enquiryId,
    }),
  );

  const handleProceedClick = () => {
    if (broker === "alliance") {
      getIncomeMultiplier().then(res => {
        if (res.message !== "Success") {
          alert(res.message);
        }
        setFewMoreQuestionsModalShow(true);
      });
    } else {
      setFewMoreQuestionsModalShow(true);
    }
  };

  return (
    <>
      <div
        css={`
          margin: 0.6em 0;
          background-color: #fff;
          box-shadow: 0px 30px 70px 0px rgb(226 232 236 / 50%);
          border-radius: 8px;
          padding: 0.7em 1em;
          width: 40%;
          font-family: ${fonts.three};

          ${mq.sm} {
            width: 100%;
          }
        `}
      >
        <p
          css={`
            font-weight: 900;
            color: #2a2a2a;
            font-family: ${fonts.three};
            text-align: center;
            padding: 0;
            margin: 0;
          `}
        >
          Your recommended Sum Assured was calculated in the following way!
        </p>
        <DetailHeading>SUMMATION OF:</DetailHeading>
        <div>
          {data &&
            data?.summation &&
            Object.entries(data?.summation).map(([key, value]) => (
              <Detail
                key={key}
                label={key}
                value={value ? amount(value) : amount(0)}
              />
            ))}
        </div>
        <DetailHeading>LESS:</DetailHeading>
        <div>
          {data &&
            data?.less &&
            Object.entries(data?.less).map(([key, value]) => (
              <Detail
                key={key}
                label={key}
                value={value ? amount(value) : amount(0)}
              />
            ))}

          <hr />
          <Detail
            label="Total Sum Assured"
            value={amount(data["Total sum assured"])}
          />
        </div>
        <div
          css={`
            margin-top: 1em;
            display: flex;
            justify-content: center;
          `}
        >
          <RadioProceed onClick={handleProceedClick}>Proceed</RadioProceed>
        </div>
      </div>
      <FewMoreQuestionsModal
        fewMoreQuestionsModal={fewMoreQuestionsModalShow}
        handleClose={() => setFewMoreQuestionsModalShow(false)}
        sumAssured={data["Total sum assured"]}
        policyTerm={data["Policy term"]}
      />
    </>
  );
}

export { ResultSheet };

const DetailHeading = styled.div`
  text-transform: uppercase;
  font-weight: 700;
  padding: 1em 0;
`;
